// extracted by mini-css-extract-plugin
module.exports = {"description":"_1nUmx","whyFranchise":"_3h_BO"};